import React from "react";

import { getTranslation } from "../../../helpers/getLanguage";
import ConfirmationModal from "../../dialogs/ConfirmationModal";

const ConfirmationRestoreModal = ({ handleCloseRestoreModal, handleRestore, getActiveTypeAndSize }) => {
  const checkEmpty = getActiveTypeAndSize().split("_")[1] === "EMPTY";

  return (
    <ConfirmationModal
      className="delete-conformation-modal"
      textContainerClass="span-delete-modal"
      closeDialog={handleCloseRestoreModal}
      message={getTranslation(`CONFIRMATION_RESTORE_MODAL_${getActiveTypeAndSize()}`)}
      autoFocus={true}
      buttonText={
        checkEmpty
          ? getTranslation("CONFIRMATION_MODAL_DEFAULT_BUTTON_TEXT")
          : getTranslation("CONFIRM_MODAL_RESTORE_BUTTON_TEXT")
      }
      onConfirm={checkEmpty ? handleCloseRestoreModal : handleRestore}
      cancelButton={!checkEmpty && getTranslation("CANCEL")}
    />
  );
};

export default ConfirmationRestoreModal;
